"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["data-track"];
const _hoisted_2 = { class: "w-full lg:w-auto" };
const _hoisted_3 = { class: "mx-auto mb-12 mt-4 w-[432px] max-w-full px-4 text-sm lg:mt-10" };
const _hoisted_4 = { class: "tw mx-auto mb-10 max-w-screen-px1408 lg:grid lg:grid-cols-[432px_1fr]" };
const _hoisted_5 = { class: "mx-auto mb-15 mt-5 w-[432px] max-w-full px-4 text-sm lg:col-[1_/_2] lg:row-[1_/_2] lg:mx-[unset] lg:mb-0 lg:mt-8 lg:w-full" };
const vue_3 = require("vue");
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const CloseButton_vue_1 = __importDefault(require("@SharedVueComponents/CloseButton/CloseButton.vue"));
const HeadlineModalMobil_vue_1 = __importDefault(require("@/components/HeadlineModalMobil.vue"));
const HeadlineModalDesktop_vue_1 = __importDefault(require("@/components/HeadlineModalDesktop.vue"));
const HeadlineLandingPage_vue_1 = __importDefault(require("@/components/HeadlineLandingPage.vue"));
const ImageLandingPage_vue_1 = __importDefault(require("@/components/ImageLandingPage.vue"));
const IntroductionText_vue_1 = __importDefault(require("@/components/IntroductionText.vue"));
const SocialLogin_vue_1 = __importDefault(require("@/components/SocialLogin.vue"));
const LoginForm_vue_1 = __importDefault(require("@/components/LoginForm.vue"));
const services_constants_js_1 = require("@ocm/services/services.constants.js");
const dataLayerLogin_1 = require("@/services/dataLayerLogin");
const store_1 = require("@/state/store");
const BottomContentModal_vue_1 = __importDefault(require("@/components/BottomContentModal.vue"));
const ImageModalDesktop_vue_1 = __importDefault(require("@/components/ImageModalDesktop.vue"));
const BenefitsLandingPage_vue_1 = __importDefault(require("@/components/BenefitsLandingPage.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'LoginPage',
    setup(__props) {
        const benefits = (0, vue_3.ref)({
            benefitItems: [],
            benefitsBackgroundImageURL: undefined,
        });
        let isFirstRequest = true;
        (0, vue_3.watch)(() => store_1.store.isLogin, () => {
            scrollContentToTop();
        });
        const loginAreaSubscriberId = (0, vue_3.ref)(null);
        (0, vue_3.onMounted)(() => {
            showLoginOrRegister();
            fetchBenefits()
                .then((response) => __awaiter(this, void 0, void 0, function* () { return yield response.json(); }))
                .then((data) => {
                benefits.value.benefitItems = data.benefitItems || [];
                benefits.value.benefitsBackgroundImageURL = buildBenefitsBackgroundImageURL(data.benefitsBackgroundImages || []);
            });
            loginAreaSubscriberId.value = ocm_mercurius_messenger_1.default.subscribe(services_constants_js_1.messengerPublicationTypes.REQUEST_LOGIN, onRequestLogin, {
                REACT_TO_LATEST: true,
            });
        });
        const loginForm = (0, vue_3.ref)(null);
        const socialLoginComponent = (0, vue_3.ref)(null);
        const loginWrapper = (0, vue_3.ref)(null);
        (0, vue_3.onBeforeUnmount)(() => {
            ocm_mercurius_messenger_1.default.unsubscribe(loginAreaSubscriberId.value);
        });
        function closeLayer() {
            ocm_mercurius_messenger_1.default.publish(services_constants_js_1.messengerPublicationTypes.ABORTED_LOGIN);
            // send Tracking for Closing Layer
            const trackingAction = store_1.store.isLogin ? "LoginLayerClosed" : "RegistrationLayerClosed";
            (0, dataLayerLogin_1.pushEvent)(trackingAction);
        }
        function scrollContentToTop() {
            if (loginWrapper.value) {
                loginWrapper.value.scrollTop = 0;
            }
        }
        function showLoginOrRegister() {
            // Prio 1: Seite mit In-Page-Registration-Button immer Registrieren
            // Prio 2: Url-Parameter urlParamLogin
            // Prio 3: Url-Parameter urlParamRegistration
            // Prio 4: localStorage (entweder gar nicht vorhanden oder "true" ist niemals "false"
            // Prio 5: modal immer LoginLandingpages, sonst (signinPage und inPageForm) immer Registrieren,
            const hasInPageRegistrationButton = !!document.querySelector("[data-registration=true]");
            const urlParamLogin = getParam("login") !== null;
            const urlParamRegistration = getParam("registration") !== null;
            const storageLoginActive = localStorage.getItem("loginTabActive") === "true";
            if (hasInPageRegistrationButton) {
                store_1.store.isLogin = false;
            }
            else if (urlParamLogin) {
                store_1.store.isLogin = true;
            }
            else if (urlParamRegistration) {
                store_1.store.isLogin = false;
            }
            else if (storageLoginActive) {
                store_1.store.isLogin = true;
            }
            else {
                store_1.store.isLogin = !store_1.store.isLandingPage;
            }
        }
        function getParam(paramName) {
            return new URLSearchParams(window.location.search).get(paramName);
        }
        function onRequestLogin() {
            var _a, _b;
            if (isFirstRequest) {
                (_a = loginForm.value) === null || _a === void 0 ? void 0 : _a.requestFirstLogin();
                isFirstRequest = false;
                return;
            }
            scrollContentToTop();
            (_b = loginForm.value) === null || _b === void 0 ? void 0 : _b.clearFormData();
            store_1.store.globalErrorMessages = [];
            store_1.store.httpErrorStatusCode = null;
        }
        function fetchBenefits() {
            // fetchLabel mit URL nur an die Stelle von der es geholt wird (so dass rest.js allgemeiner ist)
            return fetch(`${window.ocm.config.encodedContextPath}/rest/login-layer/content`);
        }
        function buildBenefitsBackgroundImageURL(responsiveImages) {
            // select largest ImageURL from responsive Images
            const responsiveImagesObj = {};
            responsiveImages.forEach((image) => (responsiveImagesObj[image.resolutionType] = image.url));
            const imageURL = responsiveImagesObj["LARGE"] || responsiveImagesObj["MEDIUM"] || responsiveImagesObj["SMALL"];
            if (!imageURL)
                return;
            // check and add resourcesHostname
            const baseImageURL = window.ocm.config.imagesHostname;
            return !baseImageURL ? imageURL : new URL(imageURL, baseImageURL).href;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (!(0, vue_2.unref)(store_1.store).isLandingPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: "tw relative h-screen w-full max-w-[1440px] overflow-hidden bg-white pt-18 lg:p-0",
                        "data-track": (0, vue_2.unref)(store_1.store).isLogin ? 'LoginLayer' : 'RegistrationLayer'
                    }, [
                        (0, vue_2.createVNode)(CloseButton_vue_1.default, {
                            class: "absolute right-4 top-4 lg:right-6.5 lg:top-6.5",
                            onClick: closeLayer
                        }),
                        (0, vue_2.createVNode)(HeadlineModalMobil_vue_1.default),
                        (0, vue_2.createElementVNode)("div", {
                            ref_key: "loginWrapper",
                            ref: loginWrapper,
                            class: "size-full overflow-auto lg:grid lg:grid-cols-2"
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                    (0, vue_2.createVNode)(HeadlineModalDesktop_vue_1.default),
                                    (0, vue_2.createVNode)(IntroductionText_vue_1.default),
                                    (0, vue_2.createVNode)(LoginForm_vue_1.default, {
                                        ref_key: "loginForm",
                                        ref: loginForm
                                    }, null, 512),
                                    (0, vue_2.createVNode)(SocialLogin_vue_1.default, {
                                        ref_key: "socialLoginComponent",
                                        ref: socialLoginComponent,
                                        class: "mb-12"
                                    }, null, 512),
                                    (0, vue_2.createVNode)(BottomContentModal_vue_1.default, {
                                        items: benefits.value.benefitItems
                                    }, null, 8, ["items"])
                                ])
                            ]),
                            (0, vue_2.createVNode)(ImageModalDesktop_vue_1.default, {
                                "img-source": benefits.value.benefitsBackgroundImageURL
                            }, null, 8, ["img-source"])
                        ], 512)
                    ], 8, _hoisted_1))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(store_1.store).isLandingPage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, {
                        key: 1,
                        to: "#LandingPageMediaComponentWrapper"
                    }, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createVNode)(ImageLandingPage_vue_1.default, { class: "lg:col-[2_/_3] lg:row-[1_/_2]" }),
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (0, vue_2.createVNode)(HeadlineLandingPage_vue_1.default),
                                (0, vue_2.createVNode)(IntroductionText_vue_1.default),
                                (0, vue_2.createVNode)(LoginForm_vue_1.default, {
                                    ref_key: "loginForm",
                                    ref: loginForm
                                }, null, 512),
                                (0, vue_2.createVNode)(SocialLogin_vue_1.default, {
                                    ref_key: "socialLoginComponent",
                                    ref: socialLoginComponent
                                }, null, 512)
                            ]),
                            (0, vue_2.createVNode)(BenefitsLandingPage_vue_1.default, {
                                items: benefits.value.benefitItems,
                                class: "lg:col-[1_/_3] lg:row-[2_/_3]"
                            }, null, 8, ["items"])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
